// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  firebase: {
    apiKey: "AIzaSyABoSn3qAZM3R_RlCU5NJVGUmbByo3nS5o",
    authDomain: "messqasystem.firebaseapp.com",
    databaseURL: "https://messqasystem.firebaseio.com",
    projectId: "messqasystem",
    storageBucket: "messqasystem.appspot.com",
    messagingSenderId: "1022282159297",
    appId: "1:1022282159297:web:8d5bd7be812d4752f0b040",
    measurementId: "G-SW01CCGS9S"
  },
  printServerUrl: 'http://localhost:5555',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
